import React from 'react';

/**
 * GateQuestion - Yes/No gate that shows/hides step content
 *
 * Used for steps like "Night" where the content may not be applicable.
 * If the user answers "Yes" (skipOnYes=true), the step content is skipped.
 */
export function GateQuestion({
  question,
  answer,
  onAnswer,
  skipOnYes = true,
  skipMessage = 'Fint! Vi går videre til neste del.',
}) {
  const shouldSkip = skipOnYes ? answer === true : answer === false;

  return (
    <div className="mb-6">
      <p className="text-lg font-medium text-text-primary mb-4">
        {question}
      </p>

      <div className="flex gap-3">
        {/* Yes button */}
        <button
          type="button"
          onClick={() => onAnswer(true)}
          className={`
            flex-1 py-4 px-6 rounded-xl
            font-semibold text-base
            transition-all duration-200
            min-h-[56px]
            ${answer === true
              ? 'bg-sage-500 text-white shadow-sage'
              : 'bg-background-card border-2 border-border-light text-text-primary hover:border-sage-300 hover:bg-sage-50/50'
            }
          `}
        >
          Ja
        </button>

        {/* No button */}
        <button
          type="button"
          onClick={() => onAnswer(false)}
          className={`
            flex-1 py-4 px-6 rounded-xl
            font-semibold text-base
            transition-all duration-200
            min-h-[56px]
            ${answer === false
              ? 'bg-sage-500 text-white shadow-sage'
              : 'bg-background-card border-2 border-border-light text-text-primary hover:border-sage-300 hover:bg-sage-50/50'
            }
          `}
        >
          Nei
        </button>
      </div>

      {/* Skip message when applicable */}
      {shouldSkip && answer !== null && (
        <div className="mt-4 p-4 bg-sage-50 rounded-lg border border-sage-200 animate-fade-in">
          <div className="flex items-center">
            <svg
              className="w-5 h-5 text-sage-600 mr-2 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-sage-800">{skipMessage}</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default GateQuestion;
